import React from 'react';
import DataCache from "../../StaticData/StaticDataCache";
import TierDropdownLookup from "../../CheckQueries/Models/Lookups/TierDropdownLookup";
import { CatalogueEntry } from "../CatologueEntry";
import { IGeneralApiClient } from "../../../Common/ApiClients/GeneralApiClient";
import { Model } from "@singularsystems/neo-core";
import { NeoGrid } from '@singularsystems/neo-react';
import { TextConstants } from '../../../Common/TextConstants';
import { Catalogue } from '@singularsystems/neo-react-services';
import * as Roles from "../../../AccessControl/Models/Commands/Security/Roles"


export default class CheckQueryTierCatalogueEntry extends CatalogueEntry<TierDropdownLookup> {
    
    constructor() {
        super("Check Query Tier", TierDropdownLookup);
    }

    public getCacheEntry(cache: DataCache) {
        return cache.checkQueryTiers;
    }

    public getSaveEndpoint(apiClient: IGeneralApiClient) {
        return apiClient.saveCheckQueryTiersList;
    }

    public get editRole() {
        return Roles.CatalogueRoles.Edit;
    }

    public renderRow(item: TierDropdownLookup, meta: Model.TransformMetaType<TierDropdownLookup>) {
        return (
            <NeoGrid.Row>
                <NeoGrid.Column bind={meta.tierName} />
                <NeoGrid.Column bind={meta.deletedInd} label={TextConstants.Labels.Deleted} />
                <Catalogue.ButtonColumn />
            </NeoGrid.Row>
        )
    }
}